module.exports = "../../../../platform/assets/pageMainIcon/youth_baobiaochaxunlei8.svg";